export default {"src":"/_next/static/media/goldPlanBackground.5b6718aa.svg","height":94,"width":328,"blurWidth":0,"blurHeight":0};